import React from 'react';

const RoutesPerYearControls = ({ selectedStat, setSelectedStat }) => {
  const statOptions = [
    { value: 'cleanAscents', label: 'Clean Ascents' },
    { value: 'allAscents', label: 'All Ascents' },
    { value: 'routes', label: 'Routes' },
    { value: 'cleanRoutes', label: 'Clean Distinct Routes' },
    { value: 'climbingDays', label: 'Climbing Days' },
    { value: 'cumulativeGrade', label: 'Cumulative Grade (CGP)' },
    { value: 'cumulativeEffort', label: 'Cumulative Effort (CGE)' },
  ];

  return (
    <select 
      value={selectedStat} 
      onChange={(e) => setSelectedStat(e.target.value)}
      className="px-3 py-1.5 text-sm rounded border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
      {statOptions.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default RoutesPerYearControls;